import { authStorage } from "../../api/authStorage";
import {
  GET_ALL_USER_NOTIFICATIONS,
  ADD_NEW_LIVE_NOTIFICATION,
  SET_UNREAD_NOTIFICATION_COUNT,
  GET_USER_ALL_NOTIFICATIONS,
} from "./notificationTypes";

const initialState = {
  // user: JSON.parse(localStorage.getItem("userData")),
  user: authStorage.getAuth() || null,
  userallNotifications: [],
  totalunreads: 0,
  userallNotification: [],
  notificationPayload:[],
  totalnotifications: 0,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_USER_NOTIFICATIONS:
      return {
        ...state,
        userallNotifications: action.payload.data,
        totalunreads: action.payload.total_unread,
      };
    case ADD_NEW_LIVE_NOTIFICATION:
      const newNotification = action.payload;

      const notificationExists = state.userallNotifications.some(
        (notif) => notif._id === newNotification._id
      );

      if (notificationExists) {
        return state;
      }

      const updatedNotifications = [
        newNotification,
        ...state.userallNotifications,
      ];

      return {
        ...state,
        userallNotifications: updatedNotifications,
        totalunreads:
          state.totalunreads + (newNotification.read === false ? 1 : 0),
      };

    case SET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
        totalunreads: action.payload,
      };

       case GET_USER_ALL_NOTIFICATIONS:
      return {
        ...state,
        userallNotification: action.payload.notifications,
        totalnotifications: action.payload.total,
        notificationPayload: action.payload,
      };


      

    default:
      return state;
  }
};

export default notificationReducer;
